import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import CustomerFormModule from "../../../modules/customer/form";

const CustomerFormPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const { id } = useParams();
  const metaTitle = id
    ? t("pages.client.detail.metaTitle")
    : t("pages.client.add.metaTitle");

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/client",
          title: t("common.text.client"),
        },
        {
          link: `/client/${id || "add"}`,
          title: id ? t("common.text.detail") : t("common.text.add"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t, id]);

  return (
    <>
      <VuiHelmet title={metaTitle} />

      <CustomerFormModule />
    </>
  );
};

export default CustomerFormPage;
